<template>
  <div class="list">
    <div class="list-filter">
      <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
        <el-form-item label="巡航编号">
          <el-input size="medium" v-model="queryEntity.code" placeholder="巡航编号"></el-input>
        </el-form-item>
        <el-form-item label="观察点">
          <el-select clearable v-model="queryEntity.nodeId" size="medium" placeholder="全部观察点">
            <el-option v-for="item in nodeList" :key="item.id" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡航时间">
          <el-date-picker size="small" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
          <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="list-table">
      <el-table :data="dataList" :header-cell-class-name="headerCellClass" :max-height="tableHeight" stripe @selection-change="handleSelectionChange" size="medium">
        <el-table-column prop="no" label="序号" width="50"> </el-table-column>
        <el-table-column prop="node.name" label="观察点名称" width="120"> </el-table-column>
        <el-table-column prop="recon.code" label="巡航编号" width="160"> </el-table-column>
        <el-table-column prop="time" label="巡航点序号" width="120"> </el-table-column>
        <el-table-column prop="name" label="巡航点名称" width="160">
        </el-table-column>
        <el-table-column label="图片">
          <template #default="scope">
            <el-image style="width: 320px; height: 240px" :src="scope.row.picPath"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="captureTime" label="抓拍时间" width="160">
        </el-table-column>
        <el-table-column label="是否有警情" width="100">
          <template #default="scope">
            <div class="column-tag">
              <el-tag v-if="scope.row.hasWarn" type="danger" size="mini">是</el-tag>
              <el-tag v-else size="mini">否</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="camera.name" label="摄像机名称" width="200"> </el-table-column>
        <el-table-column prop="cruise.name" label="巡航路线名称" width="200"> </el-table-column>
      </el-table>
    </div>
    <div class="list-pager">
      <el-pagination class="list-pager-inner" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" v-model:currentPage="queryParam.pager.pageIndex" v-model:page-size="queryParam.pager.pageSize" :total="queryParam.pager.total" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext } from "@/script/core/base/ServiceData";
import {
  createNodeContext,
  createReconContext,
} from "@/script/apps/recon/config/ReconConfig";
import { Recon, ReconItem } from "@/script/apps/recon/entity/ReconEntity";
import { DictUtil } from "@/script/core/Dict";
import { ReconService } from "@/script/apps/recon/service/ReconService";
import { AppConfig } from "@/script/core/base/AppConfig";

@Options({})
export default class ReconReport extends BaseList {
  private queryEntity: Recon = {};
  private dataList: ReconItem[] = [];
  private nodeList: Node[] = [];
  private dateRange: string[] = [];

  public initData(): ServiceContext {
    this.tableHeight = this.tableHeight! + 40;
    return createReconContext();
  }

  public initQueryEntity() {
    this.queryEntity = {
      name: "",
    };
    return this.queryEntity;
  }

  protected initOptions() {
    super.initOptions();
    createNodeContext().service.loadFullList<Node[]>((data: Node[]) => {
      this.nodeList = data;
    });
  }

  public loadList() {
    if (this.queryEntity.state === "") {
      this.queryEntity.state = null;
    }
    if (this.dateRange && this.dateRange.length > 0) {
      this.dateRange[1] = this.dateRange[1].replace("00:00:00", "23:59:59");
      this.queryParam.extendMap = {
        beginTime: this.dateRange[0],
        endTime: this.dateRange[1],
      };
    } else {
      this.queryParam.extendMap = {};
    }

    (this.serviceContext.service as ReconService)
      .loadReconDetailList(this.queryParam)
      .then((response) => {
        const url = new URL(AppConfig.Config.ServerUrl);
        response.data.list.forEach((item: ReconItem) => {
          item.picPath =
            "http://" + url.hostname + "/app-cruise" + item.picPath;
        });
        this.wrapList(this, response.data);
        this.dataList = response.data.list;
      })
      .catch((error) => {
        ElMessage.error(error.message);
      });
  }

  public afterLoadList(data: any): void {}
}
</script>
